import { getOr } from 'lodash/fp'

export const getSubmitCount = (props: any): number | undefined => {
  return getOr(undefined, 'form.submitCount', props)
}
